<template>
    <div style="max-width:800px;margin:0 auto;">
        <loading :show="isLoading"></loading>
        <modal-confirm :show="showConfirm" v-on:onselect="onConfirmSelection">
            <h4>{{ confirmMsg }}</h4>
        </modal-confirm>
        <modal-x :show="showAddExtra" @onclose="showAddExtra = false"
            :content-style="{ maxWidth: '800px', height: 'calc(100% - 40px)', padding: '10px' }">
            <div>
                <div>Order Extras</div>
                <div>
                    <span v-if="catSelected === null" @click="loadCategory" class="btn btn-default">Select Category</span>
                    <span v-else @click="loadCategory" class="btn btn-default">{{ catSelected.child.name }}</span>
                </div>
                <div>
                    <input class="form-control" placeholder="amount" v-model.number="amount" />
                </div>
                <div style="text-align: right;" class="btn btn-default" @click="confirmAddExtra">Confirm Add</div>
            </div>
        </modal-x>
        <modal-x :show="showCategory" @onclose="showCategory = false"
            :content-style="{ maxWidth: '800px', height: 'calc(100% - 40px)', padding: '10px' }">
            <div>Order Extras Categories Selection</div>
            <category v-if="showCategory" :user-id="item.shopUserId" :cat-node="catNode" @catSelected="onCatChange"
                :viewMode="{}" :showCheckbox="false" cat-type="orderExtra" :expandAll="true">
            </category>
        </modal-x>
        <div style="width:100%;padding:5px;">
            <span class="btn btn-default" @click="loadItem">{{ lang.common.refresh }}</span>
        </div>

        <div>
            <div class="panel panel-default">

                <div class="panel-body" v-if="item !== null">
                    <div>
                        <h4>{{ item.shop.shopName }} </h4>
                        <!-- <div>{{ item.shop }} </div> -->
                        <div class="col-xs-12">
                            <span style="font-weight:bold;"> {{ lang.order.orderNum }}: {{ item.id }} </span>
                            <span style="color:gray;"> Date: {{ item.localCreateDate }} </span>
                        </div>


                        <div style="font-size:1.5em;width:100%;">
                            <div class="label label-info"> {{ lang.stateLabels.order[item.stateCode] }}</div>
                        </div>

                        <div>
                            <select @change="setOrderState" class="form-control" v-model.number="orderState.stateCode">
                                <option value="">Select</option>
                                <option v-for="(val, key) in lang.stateLabels.order" :value.number="key"> {{ val }}</option>
                            </select>
                        </div>
                        <div>

                            <div v-for="(orderItem, index) in item.items" class="act-order-item row"
                                :order-id="orderItem.id" style="border-bottom:1px solid gray;">
                                <div class="col-xs-12"><span style="font-weight:bold;">{{ index + 1 }}</span> <span
                                        style="color:#808080;font-size:10px;padding:4px;">REF:{{ orderItem.id }}</span>
                                </div>
                                <div class="col-xs-2">
                                    <img class="img-responsive" style="display:inline-block;max-height:100px;"
                                        :src="orderItem.post.thumbPath">
                                </div>
                                <div class="col-xs-6">
                                    {{ orderItem.title }}
                                    <br>
                                    <div v-for="pc in orderItem.propCats">
                                        {{ pc.parent.name }}:{{ pc.child.name }}
                                    </div>
                                </div>
                                <div class="col-xs-2">{{ orderItem.price }} x {{ orderItem.quant }}</div>
                                <div class="col-xs-2"> {{ orderItem.subTotal }} </div>
                            </div>

                            <div class="row" v-for="(extraItem, index) in item.orderExtras">
                                <div class="col-xs-6"></div>
                                <div class="col-xs-4">
                                    <span v-if="canAddExtra" class="btn btn-default"
                                        @click="removeExtra(extraItem)">x</span>
                                    {{ extraItem.child.name }}
                                </div>
                                <div class="col-xs-2">{{ extraItem.label.amount }}</div>
                            </div>

                            <div class="row">
                                <div class="col-xs-6"></div>
                                <div class="col-xs-6">
                                    <div style="text-align:center;">
                                        <span>{{ lang.order.total }}({{ currency }}):</span>
                                        <span v-if="isTotalReady">{{ item.orderTotal }}</span>
                                        <span class="label label-warning" v-else>{{ lang.stateLabels.order[item.stateCode]
                                        }}</span>
                                    </div>
                                </div>
                            </div>

                            <div style="text-align: right;" v-if="canAddExtra">
                                <span class="btn btn-default" @click="addOrderExtra">Add Extra</span>
                                <div>Only processing state can add extra</div>
                            </div>

                            <div>
                                <div>
                                    {{ lang.order.buyerMsg }}:<span disabled class="form-control"> {{ item.userMsg }}</span>
                                </div>
                                <div v-if="canUpdateShopReply">
                                    {{ lang.order.shopMsg }}: <span style="color:red;"> <input class="form-control"
                                            v-model="item.shopMsg" /> </span>
                                </div>
                                <div v-else>
                                    {{ lang.order.shopMsg }}: <span style="color:red;">
                                        <span disabled class="form-control"> {{ item.shopMsg }} </span>
                                    </span>
                                </div>
                                <div v-if="canUpdateShopReply" style="text-align: right;"><span class="btn btn-default"
                                        @click="updateShopReply">Update Shop Reply </span>
                                </div>
                            </div>
                            <div>


                                <div>
                                    <span style="font-weight:bold;">{{ lang.common.name }}:</span>{{ item.contact.name }}
                                    / <span style="font-weight:bold;">{{ lang.common.phone }}:</span>{{ item.contact.phone
                                    }}
                                    / <a class="btn btn-default"
                                        :href="whatsAppMsg" target="_blank">WhatsApp</a>
                                    <div>
                                        <div style="font-weight:bold;">{{ lang.contact.deliveryAddress }}:</div>
                                        <div>{{ item.contact.address }}</div>
                                    </div>
                                    <div v-if="item.contact.pickContact !== null" style="padding-left:16px;">
                                        <div class="label label-info"> {{ lang.common.pickup }} </div>
                                        <div>{{ item.contact.pickContact.title }}:{{ item.contact.pickContact.phone }}</div>
                                        <div>{{ item.contact.pickContact.address }}</div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>



                    <!-- <div v-if="paymentSelected!==null && !orderPayable" class="col-xs-12" style="text-align: center;">
                        <div class="payment-option">
                            <h3>{{lang.order.selectedPayment}}</h3>
                            <div class="payment-info">{{paymentSelected.account.info}}</div>
                            <div class="payment-account">{{paymentSelected.account.accountNo}}</div>
                            <div style="font-size:1.5em;width:100%;">
                                <div class="label label-info"> {{lang.stateLabels.order[item.stateCode]}}</div>
                            </div>
                        </div>
                    </div> -->

                </div>

            </div>

        </div>
    </div>
</template>

<script>
import modalConfirm from '../components/base/ModalConfirm.vue';
import loading from '../components/base/Loading.vue';
import apis from '../api/extApi.js';
import modalX from '../components/base/ModalX1.vue';
import category from './category.vue';
//import categoryLabels from './categoryLabels.vue';
export default {
    components: {
        modalConfirm: modalConfirm,
        loading: loading,
        modalX: modalX,
        category: category
    },
    props: ["orderId"],
    data: function () {
        return {
            apiClient: apis.api,
            showAddExtra: false,
            catSelected: null,
            amount: null,
            catCodes: apis.api.settings.catCodes,
            showCategory: false,
            catNode: null,
            item: null,
            confirmMsg: null,
            showConfirm: false,
            isLoading: false,
            orderState: { stateCode: null }
        };
    },
    computed: {
        canUpdateShopReply: function () {
            return this.item !== null && this.item.stateCode === this.apiClient.orderStateCodes.active;
        },
        canAddExtra: function () {
            return this.item !== null && this.item.stateCode === this.apiClient.orderStateCodes.active;
        },
        orderPayable: function () {
            return this.item !== null && this.item.stateCode === this.apiClient.orderStateCodes.offerReady;
        },
        isTotalReady: function () {
            return this.item !== null && this.item.stateCode !== this.apiClient.orderStateCodes.active;
        },
        lang: function () {
            return this.$store.getters.lang;
        },
        whatsAppMsg: function () {
            if (this.item && this.item.contact) {
                // var msg = `${this.lang.order.orderNum}: ${this.item.id} ${this.lang.order.isReady}: ${this.item.shop.shopName} %0a https://${this.item.shop.domainName}/orderDetail?orderId=${this.item.id}`;
                // msg = `https://wa.me/${this.item.contact.phone}?text=${msg}`;
                // return msg;

                var msg = `${this.lang.order.orderNum}: ${this.item.id} ${this.lang.order.isReady}: ${this.item.shop.shopName} %0a https://${this.item.shop.domainName}/orderDetail?orderId=${this.item.id}`;
                msg = `https://wa.me/${this.item.contact.phone}?text=${msg}`;
                return msg;
            }
            return null;
        },
        currency: function () {
            return "--"
        },
    },
    methods: {
        confirmListener: function () { },
        onConfirmSelection: function (positive) {
            this.confirmListener(positive);
        },
        updateShopReply() {
            var msg = { shopMsg: this.item.shopMsg, id: this.orderId };
            this.apiClient.updateOrderShopMsgPrms(msg).done((ret) => {
                console.log('shop reply msg call return', ret);
            });
        },
        setOrderState() {
            console.log('new state', this.orderState.stateCode);
            this.confirmMsg = "Confirm Change?";
            this.showConfirm = true;
            this.confirmListener = (confirm) => {
                console.log('confirm?', confirm);
                if (confirm) {
                    this.apiClient.setOrderStatePrms({ id: this.orderId, stateCode: this.orderState.stateCode }).done((ret) => {
                        console.log('order set state', ret);
                        this.loadItem();
                    });
                } else {
                    this.orderState.stateCode = this.item.stateCode;
                }
                this.showConfirm = false;
            }
        },
        removeExtra(item) {
            console.log('removing extra item', item);
            this.apiClient.removeOrderExtraPrms({ id: item.label.id }).done((ret) => {
                console.log("extra item removed call return", ret);
            });
        },
        confirmAddExtra() {
            var extra = {
                orderID: this.orderId,
                amount: this.amount,
                //id:0,
                catId: this.catSelected.child.catId,
                label: ""
            };
            console.log('extra to add', extra);
            this.showAddExtra = false;
            this.apiClient.addOrderExtraPrms(extra).done((ret) => {
                console.log('add extra call return', ret);
                this.loadItem();
            });
        },
        addOrderExtra() {
            this.showAddExtra = true;
        },
        loadCategory() {
            this.showCategory = true;
            this.apiClient.getCategoryNodePrms(this.catCodes.orderExtra, this.item.shopUserId).done((catNode) => {
                console.log('catNode is', catNode);
                this.catNode = catNode;
            });
        },
        onCatChange: function (catPair) {
            console.log('selected catPair', catPair);
            this.catSelected = catPair;
            this.showCategory = false;
        },
        loadItem: function () {
            this.item = null;
            this.apiClient.getShopOrderDetailPrms(this.orderId).done((data) => {
                this.item = null;
                if (data !== null) {
                    this.item = data.item;
                    this.orderState.stateCode = this.item.stateCode;
                }
            });
        }
    },
    created: function () {
        this.loadItem();
    },
    destroyed: function () {

    }
}
</script>